import React from 'react';

export const SummaryCards = ({ traces = [], costSummary = [], timeRangeLabel = 'Last 7 days' }) => {
  const totalTraces = traces.length;

  const totalCost = traces.reduce((sum, trace) => sum + (trace.total_cost || 0), 0);

  const avgLatency = traces.length > 0
    ? traces.reduce((sum, trace) => sum + (trace.total_duration_ms || 0), 0) / traces.length
    : 0;

  const errorCount = traces.filter(trace => trace.status !== '200' && trace.status !== 'success').length;

  const successCount = traces.filter(trace => trace.status === '200' || trace.status === 'success').length;
  const goalSuccessRate = totalTraces > 0 ? (successCount / totalTraces) * 100 : 0;
  const goalSuccessColor = goalSuccessRate >= 90 ? 'text-green-400' : goalSuccessRate >= 70 ? 'text-yellow-400' : 'text-red-400';

  const cards = [
    {
      title: 'Total Cost',
      value: `$${totalCost.toFixed(4)}`,
      description: timeRangeLabel,
    },
    {
      title: 'Avg Latency',
      value: `${avgLatency.toFixed(0)}ms`,
      description: 'Average duration',
    },
    {
      title: 'Total Traces',
      value: totalTraces.toString(),
      description: timeRangeLabel,
    },
    {
      title: 'Errors',
      value: errorCount.toString(),
      description: 'Failed traces',
      valueColor: errorCount > 0 ? 'text-red-400' : undefined,
    },
    {
      title: 'Success Rate',
      value: totalTraces > 0 ? `${goalSuccessRate.toFixed(1)}%` : '—',
      description: 'Across all goals',
      valueColor: goalSuccessColor,
    },
  ];

  return (
    <div className="grid gap-3 md:grid-cols-2 lg:grid-cols-5">
      {cards.map((card) => (
        <div
          key={card.title}
          className="bg-[#0d0d0d] border border-white/[0.06] rounded-md px-4 py-3"
        >
          <div className="text-[10px] text-zinc-500 uppercase tracking-wider font-mono mb-1.5">
            {card.title}
          </div>
          <div className={`text-xl font-semibold font-mono ${card.valueColor || 'text-white'}`}>
            {card.value}
          </div>
          <div className="text-[10px] text-zinc-600 mt-1">
            {card.description}
          </div>
        </div>
      ))}
    </div>
  );
};
